import { apiClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'
import { CodeType, Lookup, LookUpsVm, ApiResponse } from '@/api/types'

/**
 * Lookups Service
 * Handles all lookup management API calls
 */
export class LookupsService {
  /**
   * Get all code types (lookup types)
   */
  async getAllCodeTypes(): Promise<CodeType[]> {
    const response = await apiClient.get<ApiResponse<CodeType[]> | CodeType[]>(
      endpoints.lookupManagement.getAllCodeTypes
    )
    // Handle both wrapped and direct responses
    if (Array.isArray(response.data)) {
      return response.data
    }
    if ('data' in response.data && Array.isArray(response.data.data)) {
      return response.data.data
    }
    // Fallback: return empty array if structure is unexpected
    console.warn('Unexpected response structure for getAllCodeTypes:', response.data)
    return []
  }

  /**
   * Get code type by ID
   */
  async getCodeTypeById(id: number): Promise<CodeType> {
    const response = await apiClient.get<ApiResponse<CodeType> | CodeType>(
      endpoints.lookupManagement.getCodeTypeById(id)
    )
    // Handle both wrapped and direct responses
    if ('data' in response.data && response.data.data) {
      return response.data.data
    }
    return response.data as CodeType
  }

  /**
   * Get all lookups
   */
  async getAllLookups(): Promise<Lookup[]> {
    const response = await apiClient.get<ApiResponse<Lookup[]> | Lookup[]>(
      endpoints.lookupManagement.getAllLookups
    )
    // Handle both wrapped and direct responses
    if (Array.isArray(response.data)) {
      return response.data
    }
    if ('data' in response.data && Array.isArray(response.data.data)) {
      return response.data.data
    }
    // Fallback: return empty array if structure is unexpected
    console.warn('Unexpected response structure for getAllLookups:', response.data)
    return []
  }

  /**
   * Get lookups by code ID and optional parent ID
   */
  async getLookupsById(lookupCodeId: number, parentId?: number): Promise<Lookup[]> {
    const response = await apiClient.get<ApiResponse<Lookup[]> | Lookup[]>(
      endpoints.lookupManagement.getLookupsById(lookupCodeId, parentId)
    )
    // Handle both wrapped and direct responses
    if (Array.isArray(response.data)) {
      return response.data
    }
    if ('data' in response.data && Array.isArray(response.data.data)) {
      return response.data.data
    }
    // Fallback: return empty array if structure is unexpected
    console.warn('Unexpected response structure for getLookupsById:', response.data)
    return []
  }

  /**
   * Save or update lookups
   */
  async saveLookups(data: LookUpsVm): Promise<any> {
    const response = await apiClient.post(endpoints.lookupManagement.formSave, data)
    return response.data
  }
}

// Export singleton instance
export const lookupsService = new LookupsService()

